var map = {
	"./capa_ledneon.jpg": 328,
	"./ledneon (1).jpg": 329,
	"./ledneon (2).jpg": 330
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/LedNeon nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 17
// module chunks = 0